angular.module( 'acme.view.application.scheduler.detail', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.scheduler.detail.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var schedulerDetail = {
        name: 'application.scheduler.detail',
        url: '/detail',
        views: {
          "subview-main": {
            controller: 'SchedulerDetailController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/scheduler/detail/detail.tpl.html'
          }
        },
        data: {
          pageTitle: 'Scheduler'
        },
        resolve: {
            gantt: ['$q', function($q) {
                var q = $q.defer(),
                    promises = [
                        $.cachedScript( "/assets/dhtmlxgantt.js" ),
                        $.cachedScript( "/assets/dhtmlxgantt_undo.js" ),
                        $.cachedScript( "/assets/dhtmlxgantt_keyboard_navigation.js" )
                    ];

                $q.allSettled(promises).then(function(script, textStatus) {
                    q.resolve('done');
                });

                return q.promise;

            }]
        }
      };

    $stateProvider
      .state(schedulerDetail);
})
.filter('ellipsis', function () {
    return function (input) {
        if (input) {
            if ( input.length > 30) {
                return input.substring(0, 30) + '...';
            }
            return input;
        }
    };
});